import { useState } from "react";
import { apiURL } from "../../consts/URLs";
import { EVENTS, GET_EVENTS_BY_MODEL_ID } from "../endpointList";
import { fetchRequest, getOptions } from "../utils";
import { getCookie } from "../../utils/handleCookie";
import { cookieName } from "../../consts/cookie";

const token = getCookie(cookieName.token);

const useEvents = () => {
  const [getEventListByModelIdResponse, setEventListByModelIdResponse] =
    useState<any>();
  const [getEventListByModelIdResult, setEventListByModelIdResult] =
    useState<any>();
  const [createEventResponse, setCreateEventsResponse] = useState<any>();
  const [createEventResult, setCreateEventsResult] = useState<any>();
  const [updateEventsResponse, setUpdateEventsResponse] = useState<any>();
  const [updateEventsResult, setUpdateEventsResult] = useState<any>();
  const [deleteEventsResponse, setDeleteEventsResponse] = useState<any>();
  const [deleteEventsResult, setDeleteEventsResult] = useState<any>();

  const getEventListByModelId = (model_id: number) => {
    const url = `${apiURL}/${GET_EVENTS_BY_MODEL_ID}/${model_id}`;
    const options = getOptions({ method: "GET", token: token });
    fetchRequest(
      url,
      options,
      setEventListByModelIdResponse,
      setEventListByModelIdResult
    );
  };

  const createEvent = (obj: any) => {
    const url = `${apiURL}/${EVENTS}`;
    const options = getOptions({
      method: "POST",
      body: { ...obj },
      token: token,
    });
    fetchRequest(url, options, setCreateEventsResponse, setCreateEventsResult);
  };

  const updateEvents = (id: number, obj: any) => {
    const url = `${apiURL}/${EVENTS}/${id}`;
    const options = getOptions({
      method: "PUT",
      body: { ...obj },
      token: token,
    });
    fetchRequest(url, options, setUpdateEventsResponse, setUpdateEventsResult);
  };

  const deleteEvents = (id: number) => {
    const url = `${apiURL}/${EVENTS}/${id}`;
    const options = getOptions({ method: "DELETE", token: token });
    fetchRequest(url, options, setDeleteEventsResponse, setDeleteEventsResult);
  };

  const RESPONSES = {
    getEventListByModelIdResponse,
    createEventResponse,
    updateEventsResponse,
    deleteEventsResponse,
  };

  const RESULTS = {
    getEventListByModelIdResult,
    createEventResult,
    updateEventsResult,
    deleteEventsResult,
  };

  const CTAs = {
    getEventListByModelId,
    createEvent,
    updateEvents,
    deleteEvents,
  };

  return { RESPONSES, RESULTS, CTAs };
};
export default useEvents;
